<template>
    <div class="">
        <v-card-title class="headline pt-1 pb-5 px-0">Schedules</v-card-title>

        <div v-if="paymentType == 'Check'">
            <div v-for="(schedule, index) in schedules">
                <v-layout row>
                    <v-layout column>
                        <v-text-field
                            class="px-1 mr-1"
                            label="Check Number"
                            v-model="schedule.checkNumber"
                            type="number"
                        ></v-text-field>
                        <v-layout row>
                            <v-text-field
                                class="px-1 mr-1"
                                label="Amount"
                                placeholder="Amount"
                                v-model="schedule.amount"
                                prefix="$"
                                type="number"
                            ></v-text-field>
                            <v-menu
                                v-model="schedule.datePickerMenu"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                prepend-icon="mdi-currency-usd"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="schedule.date"
                                        :value="formatedDate(schedule.date)"
                                        label="Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="schedule.date"
                                    :min="date"
                                ></v-date-picker>
                            </v-menu>
                        </v-layout>
                    </v-layout>
                    <v-layout align-center>
                        <v-btn @click="addSchedule" flat icon color="success">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                        <v-btn
                            :disabled="index == 0"
                            @click="removeSchedule(index)"
                            flat
                            icon
                            color="#f55a4e"
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>
            </div>
        </div>
        <div v-else>
            <div v-for="(schedule, index) in schedules">
                <v-layout row>
                    <v-text-field
                        class="px-1 mr-1"
                        label="Amount"
                        placeholder="Amount"
                        v-model="schedule.amount"
                        type="number"
                        prefix="$"
                    ></v-text-field>
                    <v-menu
                        v-model="schedule.datePickerMenu"
                        :close-on-content-click="false"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="schedule.date"
                                :value="formatedDate(schedule.date)"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="schedule.date"
                            :min="date"
                        ></v-date-picker>
                    </v-menu>
                    <v-btn @click="addSchedule" flat icon color="success">
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn
                        :disabled="index == 0"
                        @click="removeSchedule(index)"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                </v-layout>
            </div>
        </div>

        <v-card-title v-if="schedulesDiscrepancy" class="pa-2">
            <div class="font-weight-regular" style="color: #D50000">
                Schedule amounts does not match the total
            </div>
        </v-card-title>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        schedules: Array,
        addSchedule: Function,
        removeSchedule: Function,
        schedulesDiscrepancy: Boolean,
        paymentType: String,
    },
    data() {
        return {
            date: new Date().toISOString().substr(0, 10),
        };
    },
    created() {},
    computed: {},
    methods: {
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
    },
};
</script>
